<template>
  <section class="overflow-auto pretty-scroll-theme">
    <iframe :src="statisticsUrl" class="w-100" style="height: 700px"></iframe>
  </section>
</template>
<script>

export default {
  name: "Statistics",
  props: {
    statisticsUrl: {
      type: String,
      required: true,
    },
  },
};
</script>
